export const SCREEN_PRINT_MIN_ITEM_COUNT = 50;
